// @flow

import React, {Fragment} from 'react';
import StarRating from '@homeaway/react-star-rating';
import gql from 'graphql-tag';
import './Rating.less';

export const fragments = {
    SERPHit: gql`
        fragment RatingSERPHit on SERPHit {
            averageRating
            reviewCount
        }
    `
};
export type Shape = {
    averageRating: number,
    reviewCount: number
};
export type Props = Shape;

const Rating = ({averageRating, reviewCount}: Shape) => {
    if (reviewCount === 0) {
        return null;
    }

    return (
        <Fragment>
            <StarRating rating={averageRating} />
            <span className="RatingReview__reviewCount">{reviewCount}</span>
        </Fragment>
    );
};

export default Rating;
